(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("antd"), require("react-dom"), require("@reduxjs/toolkit"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "antd", "react-dom", "@reduxjs/toolkit"], factory);
	else if(typeof exports === 'object')
		exports["ReactHighchartsPackage"] = factory(require("react"), require("antd"), require("react-dom"), require("@reduxjs/toolkit"));
	else
		root["ReactHighchartsPackage"] = factory(root["react"], root["antd"], root["react-dom"], root["@reduxjs/toolkit"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__2059__, __WEBPACK_EXTERNAL_MODULE__9514__, __WEBPACK_EXTERNAL_MODULE__2096__) => {
return 